import { months } from '@/helpers/constants/common'
import moment from 'moment'

function getMoment(date) {
  if (date === null) {
    return (date = '')
  } else {
    return moment(date.substring(0, 10)).format('YYYY MMM DD')
  }
}

function getMomentWithTime(dateTime) {
  if (dateTime === null) {
    return (dateTime = '')
  } else {
    return moment(dateTime.substring(0, 10)).format('D MMMM YYYY, hh:mm A')
  }
}

function exceedMomentMonth(date) {
  let showList = false
  if (date === null) {
    return (date = '')
  }
  const firstMonth = moment(date).format('l')
  const secondMonth = moment(firstMonth).add(30, 'days').calendar()
  const thisDate = moment().format('L')
  if (thisDate < secondMonth) {
    showList = true
  }
  return showList
}

function getMonthName(month) {
  return months[month - 1] || 'N/A'
}

function getYearAndMonth(year, month) {
  if (!(year && month)) return '-'
  return `${year}, ${getMonthName(month)}`
}

function getYears() {
  const currentYear = new Date().getFullYear()
  const range = (start, stop, step) =>
    Array.from(
      { length: (stop - start) / step + 1 },
      (_, i) => start + i * step
    )
  return range(currentYear, currentYear - 50, -1)
}

function getFilteredMonths(year) {
  if (year && year === new Date().getFullYear()) {
    return [...months].splice(0, new Date().getMonth() + 1)
  }
  return months
}

function getHumanizeDate(date, fullDate, addYear = 0) {
  const dates = new Date(date)
  const day = dates.getDate()
  const month = dates.getMonth()
  const year = dates.getFullYear() + addYear
  const hour = dates.getHours()
  const minute =
    dates.getMinutes() < 10 ? `0${dates.getMinutes()}` : dates.getMinutes()
  const time = hour > 12 ? `${hour - 12}:${minute} PM` : `${hour}:${minute} AM`
  return date && fullDate
    ? `${day} ${months[month]} ${year} ${time}`
    : `${day} ${months[month]} ${year}`
}

export {
  getMoment,
  getMomentWithTime,
  exceedMomentMonth,
  getMonthName,
  getYearAndMonth,
  getYears,
  getFilteredMonths,
  getHumanizeDate
}
